import { dispatch } from '@ngneat/effects';

import { logoutUser } from '../repositories/auth.actions';

/**
 * Use this function to log the User out of both SSO and TID
 */
export const logout = () => {
  dispatch(logoutUser());
};
